export const COURSE_ICONS_PATH =
  'https://assets.olimpo.grupoq.io/assets/shared';

export const COURSE_ICONS = [
  'icon-coursetype-book.svg',
  'icon-coursetype-cap.svg',
  'icon-coursetype-certificate.svg',
  'icon-coursetype-lawyer-scale.svg',
  'icon-coursetype-oab.svg'
];
